export default "__VITE_ASSET__DMqAICLv__"